import { defineComponent as _defineComponent } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { computed, ref } from 'vue'
import SelectProject from './SelectProject.vue'
import SelectSuport from './SelectSuport.vue'

export type CardSlug = keyof typeof cardComponentContent


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectCard',
  props: {
  title: null
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;

const target = ref(null)





onClickOutside(target, (event) => {
  emit('close')
})

const cardComponentContent = {
  Ajuda: () => SelectSuport,
  'Seus Projetos': () => SelectProject,
}

const iconComponentName = computed(() => cardComponentContent[props.title]())

return { __sfc: true,target, emit, props, cardComponentContent, iconComponentName }
}

})